export default __webpack_public_path__ + "static/media/background_birthday_mobile.9ac9fd49.png";